import React from 'react';
import {Route, Redirect, Switch} from "react-router";
import NewSolicitorFormHOC from "../containers/newSolicitorFormHOC";
import NewUserFormHOC from "../containers/newUserFormHOC";
import AgentsListHOC from "../containers/agentsListHOC";
import AuthorizationHOC from "../containers/authorizationHOC";
import ApplicationPolicyHOC from "../containers/applicationPolicyHOC"
import ManageSolicitorAccountHOC from "../containers/manageSolicitorAccountHOC";
import SolicitorGroupHOC from '../containers/SolicitorGroups/solicitorGroupHOC';
import SolicitorGroupSpecHOC from '../containers/SolicitorGroups/solicitorGroupSpecHOC';
import ApplicationFormReferralSettingsHOC from '../containers/applicationFormReferralSettingsHOC';
import NewApplicationHOC from '../containers/newApplicationHOC';
import ApplicationsAndPoliciesHOC from '../containers/applicationsAndPoliciesHOC';
import AcceptedTobaHOC from '../containers/acceptedTobaHOC';
import UsersListHOC from '../containers/usersListHOC';
import NotificationsHOC from '../containers/notificationsHOC';
import PremiumSettingsHOC from '../containers/PremiumSettings/PremiumSettingsHOC';
import PostedApplicationPageHOC from '../containers/postedApplicationPageHOC';
import SolicitorGroupListHOC from '../containers/SolicitorGroups/solicitorGroupsListHOC'
import ArticleFormHOC from "../containers/articles/articleFormHOC";
import  ArticlesListHOC from '../containers/articles/articlesListHOC';
import SolicitorHomePageHOC from "../containers/SolicitorGroups/solicitorHomePageHOC";
import PremiumSettingsWizardHOC from "../containers/PremiumSettings/premiumSettingsWizardHOC";
import TobaListHOC from '../containers/Tobas/tobaListHOC';
import TobaFormHOC from  '../containers/Tobas/tobaFormHOC';
import TobaHOC from '../containers/Tobas/tobaHOC';
import {ARAG_USERS} from "../helpers/variables";
import AdvancedDisbursementsListHOC from '../containers/AdvancedDisbursements/advancedDisbursementsListHOC';
import EditingSettingsHOC from '../containers/EditingSettings/editingSettingsHOC';
import ManageBrokerAccountHOC from '../containers/ManageBrokerAccount/manageBrokerAccountHOC';
import StagedPremiumSettingsCreateHOC from '../containers/PremiumSettings/stagedPremiumSettingsCreateHOC';
import StagedPremiumSettingsEditHOC from '../containers/PremiumSettings/stagedPremiumSettingsEditHOC';

import InternalAlertsHOC from '../containers/InternalAlerts/internalAlertsHOC';
import InternalAlertFormCreateHOC from '../containers/InternalAlerts/internalAlertFormCreateHOC';
import InternalAlertFormEditHOC from '../containers/InternalAlerts/internalAlertFormEditHOC';
import { TOBA_PATH } from '../helpers/variables';
import {HREF_EDITING_SETTINGS} from "../helpers/constants";

const UserContentRouter = (props) => {
       
    if (props.loggedInUserToba === false && props.displayToba === true) {
        return (
            <Switch>
                <Route path="/" component={AuthorizationHOC(['Solicitor'])(TobaHOC) }/>
            </Switch>
        )
    }
    else {
        return (
            /*
             * When adding a route, we have to add the new route also in the breadcrumb component in order
             * for the breadcrumb to work
             * */
            <div>
                <Switch>
                    <Route exact path={HREF_EDITING_SETTINGS}
                           component={AuthorizationHOC(ARAG_USERS)(EditingSettingsHOC) }/>
                    <Route exact path="/manage-user-account"
                           component={AuthorizationHOC(ARAG_USERS)(NewUserFormHOC) }/>
                    <Route exact path="/solicitors/add-solicitor"
                           component={AuthorizationHOC(ARAG_USERS)(NewSolicitorFormHOC) }/>
                    <Route exact path="/solicitors"
                           component={AuthorizationHOC(ARAG_USERS)(AgentsListHOC) }/>
                    <Route
                        exact path="/manage-account"
                        component={AuthorizationHOC(['Solicitor', 'Broker'])(
                            props.userRoles.includes('Solicitor')?
                                ManageSolicitorAccountHOC:ManageBrokerAccountHOC
                        )}
                    />
                    <Route exact path="/solicitors/solicitor-groups"
                           component={AuthorizationHOC(ARAG_USERS)(SolicitorGroupListHOC) }/>
                    <Route exact path="/solicitors/solicitor-groups/edit-solicitor-group/:id"
                           component={AuthorizationHOC(ARAG_USERS)(SolicitorGroupHOC) }/>
                    <Route exact path="/solicitors/solicitor-groups/edit-solicitor-group/:id/spec"
                           component={AuthorizationHOC(ARAG_USERS)(SolicitorGroupSpecHOC) }/>
                    <Route exact path="/app-form-referral-settings"
                           component={AuthorizationHOC(ARAG_USERS)(ApplicationFormReferralSettingsHOC) }/>
                    <Route exact path="/new-application"
                           component={AuthorizationHOC([...ARAG_USERS,'Solicitor'])(NewApplicationHOC) }/>
                    <Route exact path="/application-and-policies"
                           component={AuthorizationHOC([...ARAG_USERS,'Solicitor'])(ApplicationsAndPoliciesHOC) }/>
                    <Route exact path="/newUser" component={AuthorizationHOC(['Administrator'])(NewUserFormHOC) }/>
                    <Route path="/application-and-policies/application-policy/:id"
                           component={AuthorizationHOC([...ARAG_USERS, 'Solicitor'])(ApplicationPolicyHOC) }/>
                    <Route exact path="/premium-settings"
                           component={AuthorizationHOC(ARAG_USERS)(PremiumSettingsHOC) }/>
                    <Route exact path="/premium-settings/new-premium-settings"
                           component={AuthorizationHOC(ARAG_USERS)(PremiumSettingsWizardHOC) }/>
                    <Route exact path="/premium-settings/new-staged-premium-settings"
                           component={AuthorizationHOC(ARAG_USERS)(StagedPremiumSettingsCreateHOC) }/>
                    <Route exact path="/premium-settings/edit-staged-premium-settings/:id"
                           component={AuthorizationHOC(ARAG_USERS)(StagedPremiumSettingsEditHOC) }/>
                    <Route exact path="/premium-settings/edit-premium-settings/:id"
                           component={AuthorizationHOC(ARAG_USERS)(PremiumSettingsWizardHOC) }/>
                    <Route exact path={`/manage-account/${TOBA_PATH}`}
                           component={AuthorizationHOC([...ARAG_USERS, 'Solicitor'])(AcceptedTobaHOC) }/>
                    <Route exact path="/solicitors/add-toba"
                           component={AuthorizationHOC([...ARAG_USERS, 'Solicitor'])(AcceptedTobaHOC) }/>
                    <Route exact path="/users" component={AuthorizationHOC(['Administrator'])(UsersListHOC) }/>
                    <Route exact path="/users/edit-user/:id"
                           component={AuthorizationHOC(['Administrator'])(NewUserFormHOC) }/>
                    <Route exact path="/solicitors/edit-solicitor/:id"
                           component={AuthorizationHOC(ARAG_USERS)(NewSolicitorFormHOC) }/>
                    <Route exact path="/notifications"
                           component={AuthorizationHOC([...ARAG_USERS, 'Solicitor'])(NotificationsHOC) }/>
                    <Route exact path="/posted-application/:id"
                           component={AuthorizationHOC(['Solicitor'])(PostedApplicationPageHOC) }/>
                    <Route exact path="/articles/add-article"
                           component={AuthorizationHOC(ARAG_USERS)(ArticleFormHOC) }/>
                    <Route exact path="/articles"
                           component={AuthorizationHOC([...ARAG_USERS, 'Solicitor'])(ArticlesListHOC) }/>
                    <Route exact path="/articles/edit-article/:id"
                           component={AuthorizationHOC(ARAG_USERS)(ArticleFormHOC) }/>
                    <Route
                        exact path="/"
                        render={() => {
                            if (props.userRoles.includes('Solicitor')) {
                                return (
                                    <Redirect to="/solicitor-home" />
                                )
                            }
                            if (props.userRoles.includes('Broker')) {
                                return (
                                    <Redirect to="/" />
                                )
                            }
                            else return null;
                        }}
                    />
                    <Route
                        path="/solicitor-home"
                        component={AuthorizationHOC(['Solicitor'])(SolicitorHomePageHOC)}
                    />
                    <Route exact path={`/solicitors/${TOBA_PATH}s`}
                           component={AuthorizationHOC(ARAG_USERS)(TobaListHOC) }/>
                    <Route exact path={`/solicitors/${TOBA_PATH}s/:id`} 
                           component={AuthorizationHOC(ARAG_USERS)(TobaFormHOC) }/>
                    <Route path="/accept-toba" component={AuthorizationHOC(['Solicitor'])(TobaHOC) }/>
                    <Route exact path="/internal-alerts"
                           component={AuthorizationHOC(ARAG_USERS)(InternalAlertsHOC) }/>
                    <Route exact path="/new-internal-alert"
                           component={AuthorizationHOC(ARAG_USERS)(InternalAlertFormCreateHOC) }/>
                    <Route path="/internal-alerts/:id" component={AuthorizationHOC(ARAG_USERS)(InternalAlertFormEditHOC) }/>
                    <Route exact path="/advance-disbursements"
                        component={AuthorizationHOC(['User', 'Underwriter', 'Technical Underwriter', 'Solicitor'])(AdvancedDisbursementsListHOC)} />
                    
                    {/* All broker and quote routes redirect to Home page */}
                    <Redirect from="/brokers/edit-broker/:id" to="/" />
                    <Redirect from="/brokers/add-broker" to="/" />
                    <Redirect from="/brokers" to="/" />
                    <Redirect from="/quote/:id" to="/" />
                    <Redirect from="/quote" to="/" />
                    <Redirect from="/quotes" to="/" />
                    {/* <Route path="/new-application"
                           component={AuthorizationHOC(ARAG_USERS)(NewApplicationHOC) }
                           /> */}
                </Switch>
            </div>
        )
    }
};

export default UserContentRouter;
